import React from "react";
import { Container } from "reactstrap";



const AlertComponent = ({ name }) => {
    return (
        <Container fluid>
            <div class="ant-row design-mini-panels" style={{ padding: "20px", rowGap: "20px", marginLeft: "-20px", marginRight: "-20px" }}>
                <div class="ant-col ant-col-xs-24 ant-col-sm-6"></div>
                <div class="ant-col ant-col-xs-24 ant-col-sm-12">
                    <div style={{ textAlign: "center", padding: "20px", fontSize: "17px" }}>
                        <h5> Nuk gjendet asnjë {name} nga kërkimi i bërë!</h5>
                    </div>
                </div>
                <div class="ant-col ant-col-xs-24 ant-col-sm-6"></div>
            </div>
        </Container>
    );
};

export default AlertComponent;
